<template>
<ul class="templateList">
  <li v-for="(item, index) in list" class="item" :data-id="item.id" @click="(event)=>{click(event, index)}">
<!--    <button v-if="editerMode && listType == 'template'" @click="(event)=>{edit(event, index)}">수정</button>-->
    <button v-if="item.mode == 'process'">{{item.publicActive? "전체공개" : "비공개"}}</button>
    <div class="img">
      <!-- {{ item.src }} -->
      <img :src="item.src" />
      <!-- <img v-if="item.src"  :src="item.src" /> -->
      <!-- <p v-if="!item.src">aaaa</p> -->
    </div>
    <p class="title">
      <span class="field" v-if="item.field && listType == 'process' ">{{item.field}}</span>
      <span>[{{item.companyCode == '' || item.companyCode == null ? "-" : item.companyCode}}]</span>
      <span v-html="item.title"></span>
    </p>
    <p class="title">
      <span class="date">{{item.mode == 'process'? '수정일시':'공개일시'}} : {{item.updateDate.replace("T"," ")}}</span>
    </p>
  </li>
</ul>
</template>

<script>
import CommNew from "@processEditor/CommNew";

export default {
  mixins : [ CommNew ] , 
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    listType : {
      type : String,
      default(){
        return "process"
      }
    }
  },
  data(){
    return {
      editerMode : false,
    }
  },
  mounted () {
    // console.log( "this.listType",  this.listType)
    if( this.user.admin || this.user.super ) this.editerMode = true;
    // console.log( this.list ) ; 
  } , 
  methods: {
    click(event,index) {
      this.$emit('click', this.list[index], index, event);
    },
    edit(event,index){
      event.preventDefault();
      event.stopPropagation();
      this.$router.push({
        path: "/process/editor",
        query: {
          processId: this.list[index].processId,
          editorType: "process",
        },
      });      
    }
  }
}
</script>

<style lang="scss">
.templateList {
  display: flex; flex-wrap: wrap; gap: 24px var( --default-gap );
  max-width: 930px;
  overflow: auto;
  .item {
      max-width: 330px;
      cursor: pointer;
      position:relative;
    button{
      position:absolute;
      right:10px;top:10px;
      border:1px solid #ddd;
      padding:5px 8px;
      background:rgba(255,255,255,0.7);
      border-radius:3px;
      font-size: 12px;
      font-weight: bold;
    }
    .img {
      display: flex; align-items: center; justify-content: center;
      // width: 290px; height: 160px;   
      width: 100%;
      padding: 10px;
      border: 1px solid #999;
      margin: 0 0 var( --default-gap ) 0;
      // background-color: #f5f5f5;
      img {
        width: auto;
        max-width: 100%; max-height: 100%;
      }
    }
    p.title {
      display: flex; align-items: center; justify-content: center;
      gap: 4px;
      span {
        display: block;
      }
      span.field {
        display: inline-flex; align-items: center; justify-content: center;
        min-width: 32px; min-height: 15px;
        flex-shrink: 0;
        padding: 3px 5px;
        background-color: #333;
        border-radius: 12px;
        color: #fff;
        font-size: 11px;
      }
      span.date {
        font-size: 13px;
      }
      font-size: 14px;
      @include text-prt-sb;
    }
  }
}  
</style>